import { IPropertyViewData } from "../property/PropertyViewData";

export default interface IInstrumentTypeFormData {
    isEditMode: boolean;
    isAssociatePropertyVisible: boolean;
    requestId: string;
    id: string;
    name: string;
    description: string;
    properties: IPropertyViewData[];
    formLoading?: boolean
    nameError?: boolean
}

export class InstrumentTypeFormData implements IInstrumentTypeFormData {
    isEditMode: boolean;
    isAssociatePropertyVisible: boolean;
    requestId: string;
    id: string;
    name: string;
    description: string;
    properties: IPropertyViewData[];

    constructor(isEditModa: boolean, requestId: string, id: string, name: string, description: string, properties: IPropertyViewData[]) {
        this.isEditMode = isEditModa;
        this.requestId = requestId;
        this.id = id;
        this.name = name;
        this.description = description;
        this.properties = properties;

        this.isAssociatePropertyVisible = false;
    }
}

const defaultInstrumentTypeFormData = new InstrumentTypeFormData(false, "", "", "", "", []);
export { defaultInstrumentTypeFormData };